import React, { Component } from "react";
import { Form, Select, Upload, Space, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import ButtonItem from "../../../../../Components/ButtonItem";
import axios from "axios";
import ModalItem from "../../../../../Components/ModalItem";
import FormItem from "../../../../../Components/FormItem";
import InputItem from "../../../../../Components/InputItem";
import TextAreaItem from "../../../../../Components/TextAreaItem";
import SelectItem from "../../../../../Components/SelectItem";

const { Option } = Select;

class AgregarManual extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    uploadedPdfUrl: null,
    fileList: []
  };

  componentDidUpdate(prevProps) {
  if (this.props.visible && !prevProps.visible) {
    this.limpiarFormulario();
  }
}


  limpiarFormulario = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      uploadedPdfUrl: null,
      fileList: []
    });
  };

  // Configuración de upload
  getUploadProps = () => ({
    name: "pdf",
    accept: ".pdf",
    maxCount: 1,
    fileList: this.state.fileList,
    beforeUpload: (file) => {
      this.setState({ fileList: [file] });
      return false;
    },

    onRemove: () => {
      this.setState({ fileList: [] });
    }
  });




  // Guardar manual (solo agregar)
  handleSubmit = async (values) => {
    const { empresaId, onSuccess } = this.props;
    const { fileList } = this.state;

    if (fileList.length === 0) {
      message.error("Debes seleccionar un archivo PDF");
      return;
    }

    this.setState({ loading: true });

    try {
      // 1️⃣ SUBIR ARCHIVO PDF AL BACK
      const rawFile = fileList[0];

    // 2️⃣ Convertirlo a File puro
    const cleanedFile = new File(
      [rawFile], 
      rawFile.name, 
      { type: rawFile.type }
    );

      const formData = new FormData();
      formData.append("pdf", cleanedFile); // AQUÍ va el File real

      const uploadResponse = await axios.post(
        "/manuales/uploadPDF",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // <-- obligatorio
            ...this.props.headersToken.headers     // <-- después
          }
        }
      );


      if (uploadResponse.data.success !== 2) {
        message.error(uploadResponse.data.message || "Error al subir PDF");
        this.setState({ loading: false });
        return;
      }

      const pdfUrl = uploadResponse.data.pdfUrl;

      // 2️⃣ GUARDAR MANUAL EN LA BD
      const payload = {
        ...values,
        empresaId,
        pdfUrl
      };

      const response = await axios.post(
        "manuales/agregarManual",
        payload,
        this.props.headersToken
      );

      if (response.data.success === 2) {
        message.success("Manual agregado correctamente");
        this.limpiarFormulario();
        onSuccess();
      } else {
        message.error(response.data.message || "Error al guardar el manual");
      }

    } catch (error) {
      console.error(error);
      message.error("Error al conectar con el servidor");
    } finally {
      this.setState({ loading: false });
    }
  };



  handleCancel = () => {
    this.limpiarFormulario();
    this.props.onCancel();
  };

  render() {
    const { visible } = this.props;
    const { loading } = this.state;

    return (
      <ModalItem
        title="Agregar Manual"
        visible={visible}
        spinning={loading}
        onCancel={this.handleCancel}
        footer={null}
        width={600}
        destroyOnClose
      >
        <Form
          ref={this.formRef}
          layout="vertical"
          onFinish={this.handleSubmit}
        >
          <FormItem
            name="titulo"
            label="Título"
            rules={[
              { required: true, message: "Ingresa el título" },
              { max: 100, message: "Máximo 100 caracteres" }
            ]}
          >
            <InputItem placeholder="Ej: Manual de Usuario" />
          </FormItem>

          <FormItem
            name="descripcion"
            label="Descripción"
            rules={[
              { required: true, message: "Ingresa la descripción" }
            ]}
          >
            <TextAreaItem rows={3} placeholder="Breve descripción" />
          </FormItem>

          <FormItem
            name="categoria"
            label="Categoría"
            rules={[{ required: true, message: "Selecciona una categoría" }]}
          >
            <SelectItem placeholder="Selecciona una categoría">
              <Option value="General">General</Option>
              <Option value="Configuración">Configuración</Option>
              <Option value="Técnico">Técnico</Option>
              <Option value="Contabilidad">Contabilidad</Option>
              <Option value="Fiscal">Fiscal</Option>
              <Option value="Reportes">Reportes</Option>
            </SelectItem>
          </FormItem>

          <FormItem
            name="paginas"
            label="Número de Páginas"
            rules={[{ required: true, message: "Ingresa el número de páginas" }]}
          >
            <InputItem placeholder="Ej: 45 páginas" />
          </FormItem>

          <FormItem
            name="orden"
            label="Orden de visualización"
            tooltip="Menor número = aparece primero"
            initialValue={0}
          >
            <InputItem type="number" placeholder="0" min={0} />
          </FormItem>

          <FormItem
            label="Archivo PDF"
            required={true}
            extra="Solo archivos PDF, máximo 10MB"
          >
            <Upload {...this.getUploadProps()}>
              <ButtonItem icon={<UploadOutlined />}>Subir PDF</ButtonItem>
            </Upload>
          </FormItem>

          <FormItem style={{ marginBottom: 0, marginTop: 24 }}>
            <Space style={{ width: "100%", justifyContent: "flex-end" }}>
              <ButtonItem onClick={this.handleCancel}>Cancelar</ButtonItem>
              <ButtonItem type="primary" htmlType="submit" loading={loading}>
                Agregar
              </ButtonItem>
            </Space>
          </FormItem>
        </Form>
      </ModalItem>
    );
  }
}

export default AgregarManual;
